import { formatRelative, parseISO } from 'date-fns'
import { sv } from 'date-fns/locale'

// The defaut sv locale is not entirely satisfying so we make some small adjustemets
const formatRelativeLocale = {
  lastWeek: "'I' EEEE's' p",
  yesterday: "'Igår' p",
  today: "'Idag' p",
  tomorrow: "'Imorgon' p",
  nextWeek: 'EEEE p',
  other: "d MMM HH':'mm",
}

// Extends the swedish locale with our adjustements, exported for testability
export const defaultOptions = {
  locale: {
    ...sv,
    formatRelative: (token) => formatRelativeLocale[token],
  },
}

/**
 * Wrapper around date-fns/formatRelative with custom locale
 * Only accepts dates as ISO strings
 */
export default (dateISO, baseDateISO) => {
  return formatRelative(
    parseISO(dateISO),
    baseDateISO ? parseISO(baseDateISO) : new Date(),
    defaultOptions,
  )
}
